import { usePopup } from '@contexts/popupContext';
import { Loader } from '@shared/designSystem/Loader';
import styles from '@styles/components/Novedades/RemoverColaborador.module.css';
import { useState } from 'react';
import ResultPopup from '@components/General/ResultPopup';

const DeleteConfirmationPopup = ({
	title,
	message,
	onDelete,
	onSuccess,
	successMessage,
	errorMessage,
	confirmButtonText = 'Eliminar'.localized(),
	cancelButtonText = 'Cancelar'.localized(),
}) => {
	const { hidePopup, showPopup } = usePopup();
	const [loading, setLoading] = useState(false);

	const handleConfirmDelete = async () => {
		setLoading(true);
		try {
			await onDelete();
			showPopup(() => <ResultPopup result={successMessage} succesful={true} />);
			onSuccess?.();
		} catch (error) {
			showPopup(() => <ResultPopup result={errorMessage} succesful={false} />);
			console.error(error);
		}
		setLoading(false);
	};

	return (
		<div className={styles['popup']}>
			<div className={styles['title']}>{title}</div>
			<div className={styles['warning-text']}>{message}</div>

			<div className={styles['bottom-container']}>
				<div className={`${styles['button']} ${styles['cancelar']}`} onClick={hidePopup}>
					{cancelButtonText}
				</div>

				<div
					className={`${styles['button']} ${styles['agregar']}`}
					onClick={handleConfirmDelete}>
					{!loading ? (
						confirmButtonText
					) : (
						<div className={styles['no-qontact-points']}>
							<Loader height="32px" width="32px" />
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default DeleteConfirmationPopup;
